import { Component, OnInit } from '@angular/core';
import { ColumnMode } from "@swimlane/ngx-datatable";
import { DashboardService } from '../../../shared/services/pubServices/dashboard.service';
import { SignalrService } from 'src/app/shared/services/websecket/signalr.service';
import { browserRefresh } from '../../../app.component';
import { Subscription } from 'rxjs'
import { PaymentsService } from 'src/app/shared/services/pubServices/payments.service';
import { Payterm } from '../../../models/pubModel/method.model';
import { StatsService } from 'src/app/shared/services/pubServices/stats.service';
import { Ianalytics} from '../../../shared/filters/filters';

@Component({
  selector: 'adm-dash-component',
  templateUrl: './dash-component.html',
  styleUrls: ['./dash-component.scss']
})
export class dashboardComponent implements OnInit{
  public browserRefresh: boolean;
  conversionActivated: Subscription;

  // MTD for cards %
  mtd_revenue: number = 0;
  div_revenue: number = 0;
  lm_revenue: number = 0;
  percent_revenue: boolean;


  mtd_clicks: number = 0;
  div_clicks: number =0;
  lm_clicks: number = 0;
  percent_clicks: boolean;

  mtd_conversions: number = 0;
  div_conversions: number = 0;
  lm_conversions: number = 0;
  percent_conversions: boolean;

  // chart options
  chart1Option: any;
  chart2Option: any;

  // date
  today: any;

  // table options
  chart: any;
  chart2: any;
  isChart: boolean;
  isChart2: boolean;

  lastConversions: any;
  topconverting: any;
  newest: any;
  expired: any;

  request : Ianalytics = {dateRange:5, dateMonth:0, groupBy:3, groupByOfferCountry:0, itemDetails:"0"};

  ColumnMode = ColumnMode;

  payout = new Payterm();

  constructor(private dashboardService: DashboardService,
              private signalrService: SignalrService,
              private paymentsService: PaymentsService,
              private statsService: StatsService) {

  }

  ngOnInit() {

    this.today = Date.now();
    
    // aktywacja obserwatora
    this.conversionActivated = this.signalrService.newConversionActivated.subscribe((id)=>{
      if(id==1){
        this.getChart();
        this.getChart2();        
        this.getLastConversions();
        this.getPaymentsDetails();
        this.getKlocki();
      }
    })
    // weryfikacja czy nastąpiło refreshe page (F5)
    this.browserRefresh = browserRefresh;
    if(this.browserRefresh)
    {
      this.signalrService.startConnection();
      this.signalrService.newConversionListener();
    }

    this.getChart();
    this.getChart2();
    this.getPaymentsDetails();
    this.getLastConversions();
    this.getOffers();
    this.getKlocki();
  }

  getKlocki(){
    // mtd oraz dateRange = 5; - oznacza od początku obecnego miesiąca do dziś
    // dane z obecnego miesiąca
    this.request.dateRange = 5;
    this.request.dateMonth = 0;
    this.statsService.getAnalytics(this.request)
    .subscribe(
    data => {
      
        // obecny miesiąc o początku do dziś
        this.mtd_clicks = data.data.cards.clicks;
        this.mtd_conversions = data.data.cards.conversions;
        this.mtd_revenue = data.data.cards.revenue;
        
        // -------------------------------------------------------------
        // dane z poprzedniego miesiąca
        this.request.dateRange = 6;
        const d = new Date();
        // dateRange = 6; oznacza konkretny miesiąc, ma być poprzedni
        // d.getMonth() zwraca wartość od zera = January
    
        this.request.dateMonth = d.getMonth();
        if(this.request.dateMonth == 0)
          this.request.dateMonth = 12;

        this.getLastmonth(this.request);
    },
    error => {
      console.log(error);
    });

    // -------------------------------------------------------------
    // ustalenie czy trend jest zwyżkowy czy zniżkowy
    if( this.mtd_revenue/this.lm_revenue < 1)
      this.percent_revenue = false;
    else
      this.percent_revenue = true;

    if( this.mtd_clicks/this.lm_clicks < 1)
      this.percent_clicks = false;
    else
      this.percent_clicks = true;

    if( this.mtd_conversions/this.lm_conversions < 1)
      this.percent_conversions = false;
    else
      this.percent_conversions = true;
  }

  getLastmonth(data: any){
      this.statsService.getAnalytics(data)
      .subscribe(
      data => {
        // poprzedni miesiąc
        const d = new Date();

        // revenue
        this.lm_revenue = 0;
        for(let i=0; i < (d.getDate()-1); i++){
          if(i <= data.data.chart.revenue.length)
            this.lm_revenue = this.lm_revenue +  data.data.chart.revenue[i];
        }
        if(this.mtd_revenue/this.lm_revenue > 1)
          this.div_revenue = this.mtd_revenue/this.lm_revenue - 1;
        if(this.mtd_revenue/this.lm_revenue < 1)
          this.div_revenue = 1 - this.mtd_revenue/this.lm_revenue;

        // clicks
        this.lm_clicks = 0;
        for(let i=0; i < (d.getDate()-1); i++){
          if(i <= data.data.chart.clicks.length)
            this.lm_clicks = this.lm_clicks +  data.data.chart.clicks[i];
        }
        if(this.mtd_clicks/this.lm_clicks > 1)
          this.div_clicks = this.mtd_clicks/this.lm_clicks - 1;
        if(this.mtd_clicks/this.lm_clicks < 1)
          this.div_clicks = 1 - this.mtd_clicks/this.lm_clicks;

        // conversions
        this.lm_conversions = 0;
        for(let i=0; i < (d.getDate()-1); i++){
          if(i <= data.data.chart.conversions.length)
            this.lm_conversions = this.lm_conversions +  data.data.chart.conversions[i];
        }

        if(this.mtd_conversions/this.lm_conversions > 1)
          this.div_conversions = this.mtd_conversions/this.lm_conversions - 1;
        if(this.mtd_conversions/this.lm_conversions < 1)
          this.div_conversions = 1 - this.mtd_conversions/this.lm_conversions;      

      },
      error => {
        console.log(error);
      });
  }

  getPaymentsDetails(): void {
    this.paymentsService.getPaymentsDetails()
    .subscribe(
      data => {
        this.payout.preffered = data.data.prefferedPayoutMethod.name;
        this.payout.payTerm = data.data.payoutTerm.name;
        this.payout.minAmount = data.data.minAmount;
        this.payout.currentRevenue = data.data.currentRevenue;
        this.payout.payoutDate = data.data.nextPayoutDate;
        this.payout.wireFee = data.data.payoutMethodDetails.wire.paymentFeeForEachRequest;
        this.payout.payoneerFee = data.data.payoutMethodDetails.payoneer.paymentFeeForEachRequest;
        this.payout.payPalFee = data.data.payoutMethodDetails.payPal.paymentFeeForEachRequest;
      },
      error => {
        console.log(error);
      });
  }

  getLastConversions(){
    this.dashboardService.getLastConversions()
    .subscribe(
     data => {
      this.lastConversions = data.data;
     },
     error => {
       console.log(error);
     });
  }

  getOffers()
  {
    this.dashboardService.getOffers()
    .subscribe(
     data => {
      this.topconverting = data.data.topCovertingOffers;
      this.newest = data.data.newestOffers;
      this.expired = data.data.lastExpiredOffers;
     },
     error => {
       console.log(error);
     });
  }

  getChart(){
    this.dashboardService.getChart()
    .subscribe(
     data => {
      this.chart = data.data;
      if(this.chart.category.length === 0 )
        this.isChart=false;
      else{
        this.Chart1Option();
      }
     },
     error => {
       console.log(error);
     });
  }

  getChart2(){
    this.dashboardService.getChart2()
    .subscribe(
     data => {
      this.chart2 = data.data;
      if(this.chart2.category.length === 0 )
        this.isChart2=false;
      else{
        this.Chart2Option();
      }
     },
     error => {
       console.log(error);
     });
  }

  Chart1Option(){
    this.isChart=true;
    this.chart1Option = {
      tooltip: {
        trigger: 'axis',
        borderRadius: 4,
        borderWidth: 1,
        borderColor: '#333',
        backgroundColor: 'rgba(255,255,255,0.9)',
        axisPointer: {
          // Use axis to trigger tooltip
          type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
        }
      },
      legend: {},
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: this.chart.category
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          name: 'Visitors',
          type: 'bar',
          stack: 'total',
          itemStyle: {color: '#f6a821'},
          label: {
            show: true
          },
          emphasis: {
            focus: 'series'
          },
          data: this.chart.visitors
        },
        {
          name: 'Clicks',
          type: 'bar',
          stack: 'total',
          itemStyle: {color: '#c4861a'},
          label: {
            show: true
          },
          emphasis: {
            focus: 'series'
          },
          data: this.chart.clicksPerDay
        },
        {
          name: 'Convertions',
          type: 'bar',
          stack: 'total',
          itemStyle: {color: '#936413'},
          label: {
            show: true
          },
          emphasis: {
            focus: 'series'
          },
          data: this.chart.conversionsPerDay
        }
      ]
    };
  }

  Chart2Option(){
    this.isChart2=true;
    this.chart2Option = {
      title: {
        text: 'Revenue'
      },
      tooltip: {
        trigger: 'axis',
        borderRadius: 4,
        borderWidth: 1,
        borderColor: '#333',
        backgroundColor: 'rgba(255,255,255,0.9)',
        axisPointer: {
          // Use axis to trigger tooltip
          type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
        }
      },
      // legend: {},
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: this.chart2.category
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          name: 'Revenue',
          type: 'line',
          lineStyle: {
            color: '#ff6018',
            width: 5
          },
          tooltip: {
            valueFormatter: value => value.toFixed(2) + ' $'
          },
          label: {
            show: true,
            formatter: function (param: any) {
              var ilosc = param.value;
              if(ilosc > 0)
                {return param.value.toFixed(2)}
              else
                return '';
              }
          },
          markPoint: {
            symbol: "pin",
            symbolSize: 80,
            label: {
              color: 'white',
              fontWeight: 'bold',
              formatter: function (param: any) {
                var ilosc = param.value;
                if(ilosc > 0)
                  {return param.value.toFixed(2)}
                else
                  return '';
                }
            },
            itemStyle: {
              color: '#ff6018',
              opacity: 0.7,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
              shadowBlur: 10
            },
            data: [
              { type: 'max', name: 'Max' }
            ]
          },
          markLine: {
            label: {
              position: "end",
              distance: 0
            },
            lineStyle: {
              color: '#ff6018'
            },
            data: [{ type: 'average', name: 'Avg' }]
          },
          data: this.chart2.revenuePerDay
        }
      ]
    };
  }
}
